<template>
  <v-card v-if="localEducation">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-row>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="localEducation.year_start"
                label="Début (année)"
                :items="validYears"
                clearable
                @change="calculatedDuration"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="localEducation.year_end"
                label="Fin (année)"
                :items="validYears"
                clearable
                @change="calculatedDuration"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field type="number" label="durée (année):" v-model="localEducation.duration"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="localEducation.study_type"
                label="Type de formation"
                :items="possibleStudyTypes"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4" v-if="localEducation.study_type === 'Universitaire'">
              <v-checkbox
                v-model="localEducation.is_equivalence"
                label="Une  demande d’équivalence auprès de la Confédération est-elle en cours pour reconnaître un titre?"
              ></v-checkbox>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Lieu de formation:" v-model="localEducation.establishment"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-if="countries"
                v-model="localEducation.country"
                :items="countries"
                item-text="title"
                item-value="code"
                :label="`Pays`"
                prepend-icon="mdi-city"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="*certificat/attestation"
                v-model="localEducation.certificate_issued"
                required
                :rules="[() => !!localEducation.certificate_issued || 'Champ obligatoire']"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.native="close">Annuler</v-btn>
        <v-btn :disabled="isDisabled" color="primary" @click.native="save">Sauvegarder</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { cloneDeep } from "lodash"
import Education from "../../models/Education"

export default {
  props: {
    education: {
      required: true,
    },
    student_id: {
      required: true,
    },
    formTitle: {
      type: String,
      default: "Modifier",
    },
  },
  async mounted() {
    this.localEducation = cloneDeep(this.education)
    await axios.get("/api/v1/countries").then((data) => {
      this.countriesObject = data.data
    })
  },
  watch: {
    education: function () {
      this.localEducation = cloneDeep(this.education)
    },
    "education.year_start": "calculateDuration",
    "education.year_end": "calculateDuration",
  },
  data() {
    return {
      valid: false,
      localEducation: null,
      countriesObject: null,
    }
  },
  computed: {
    isDisabled() {
      return !this.localEducation.study_type || !this.localEducation.country
    },
    validYears: () => {
      let max = new Date().getFullYear()
      let min = max - 70
      let years = []
      for (let i = max; i >= min; i--) {
        years.push(i)
      }
      return years
    },
    countries() {
      // convert key-value country objects {"AF": "Afghanistan"}
      // to {"code": "AF", "title": "Afghanistan"} array
      if (!this.countriesObject) {
        return null
      }
      let cObj = this.countriesObject
      return Object.keys(cObj).map(function (key) {
        let element = {}
        element["code"] = key
        element["title"] = cObj[key]
        return element
      })
    },
    possibleStudyTypes() {
      return Education.possibleStudyTypes
    },
  },
  methods: {
    save() {
      this.$emit("save", this.localEducation)
    },
    close() {
      {
        this.$emit("cancel")
      }
    },
    calculatedDuration() {
      const startDate = this.localEducation.year_start
      const endDate = this.localEducation.year_end

      if (startDate && endDate) {
        const duration = endDate - startDate
        this.localEducation.duration = duration
      }
    },
  },
}
</script>
